import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Row from 'reactstrap/es/Row';
import Col from 'reactstrap/es/Col';
import Button from 'reactstrap/es/Button';
import { toast } from 'react-toastify';
import { SelectFile } from '@yooink/youtils/es/SelectFile';
import Api from './Api';

export default function LocalizationManager () {
	const [stats, setStats] = useState();
	function updateStat () {
		Api.fetchStats().then((data) => setStats(data.stats));
	}
	useEffect(updateStat, []);

	function loadFile () {
		SelectFile({ accept: 'text/csv', multiple: false }, async (files) => {
			const data = await Api.uploadNewLocale(files[0]);
			if (data.status) {
				toast.success('Файл локализации успешно применён');
				updateStat();
			} else {
				toast.error(data.message);
			}
		});
	}
	return (
		<div>
			<div className="d_title">Модуль управления локализацией</div>
			<div className="d_box">
				<Row>
					<Col>
						<Link to="/system/localization/i18n">
							<Button color="link" className="btn_main">Системная локализация</Button>
						</Link>
						<br />
						<pre>
							{JSON.stringify(stats, null, 4)}
						</pre>
						<a href="/api/v2/locale/csv" className="link" download>Скачать файл локализации системы</a>
						<br />
						<a href="/api/v2/locale/csv?onlyRequired=true" className="link" download>Получить файл для перевода новый строк</a>
					</Col>
					<Col>
						<h2>Загрузка локали</h2>
						<Button onClick={loadFile} color="link" className="btn_main">Загрузить файл с локализацией</Button>
					</Col>
				</Row>
			</div>
		</div>
);
}
